<template>
  <div class="">

    <div class="container mt-4 mb-2">
      <div class="icon-container">
        <i @click="openModalAddParametros('', codigo, -1)" class="fas fa-plus plus-icon"></i>
      </div>
    </div>

    <!-- Segmentação -->
    <div :id="`segmentacao-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasSegmentacoes">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-segmentacao`, 'section', `accordion-services-${codigo}-seg`)"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}-seg`">
              <i class="fa fa-angle-right" :id="`icon-services-${codigo}-segmentacao`" aria-hidden="false"></i>
              <span>Segmentação</span>
            </button>
            <div></div>
            <div @click="openModalAddSegmentacao(codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <segmentacoesTabs ref="segTabs" :codigo="codigo" @onVerSegmentacao="abrirModalViewSegmentacao" />

      </div>
    </div>

    <!-- Atributos Header -->
    <div v-if="header === true" :id="`header-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasServicos">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-header`, 'section', `accordion-services-${codigo}1`), pesquisarServicoMenu()"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}1`">
              <i :id="`icon-services-${codigo}-header`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span>Header</span>
            </button>
            <div>
            </div>
            <div @click="openModalAddParametros('Header', codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <AtributesTabs :listaDadosAtributosHierarquia="listaDadosServicoAtributosHierarquia"
          @onAction="onActionInComponent" :entrada="String('H')" :ordem="String('1')" :menu="menu"
          :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)" />
      </div>
    </div>

    <!-- Atributos Get -->
    <div v-if="get === true" :id="`get-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasServicos">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-get`, 'section', `accordion-services-${codigo}2`), pesquisarServicoMenu()"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}2`">
              <i :id="`icon-services-${codigo}-get`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span>Get</span>
            </button>
            <div @click="openModalAddParametros('Get', codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <AtributesTabs :listaDadosAtributosHierarquia="listaDadosServicoAtributosHierarquia"
          @onAction="onActionInComponent" :entrada="String('G')" :ordem="String('2')" :menu="menu"
          :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)" />
      </div>
    </div>





    <!-- Atributos Entrada -->
    <div v-if="entrada === true" :id="`entrada-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasServicos">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-entrada`, 'section', `accordion-services-${codigo}3`), pesquisarServicoMenu()"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}3`">
              <i :id="`icon-services-${codigo}-entrada`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span>Entrada </span>
            </button>
            <div @click="openModalAddParametros('Entrada', codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <AtributesTabs :listaDadosAtributosHierarquia="listaDadosServicoAtributosHierarquia"
          @onAction="onActionInComponent" :entrada="String('E')" :ordem="String('3')" :menu="menu"
          :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)" />
      </div>
    </div>

    <!-- Atributos Form -->
    <div v-if="form === true" :id="`form-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasServicos">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-form`, 'section', `accordion-services-${codigo}4`), pesquisarServicoMenu()"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}4`">
              <i :id="`icon-services-${codigo}-form`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span>Form</span>
            </button>
            <div @click="openModalAddParametros('Form', codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <AtributesTabs :listaDadosAtributosHierarquia="listaDadosServicoAtributosHierarquia"
          @onAction="onActionInComponent" :entrada="String('F')" :ordem="String('4')" :menu="menu"
          :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)" />
      </div>
    </div>

    <!-- Atributos Body -->
    <div v-if="body === true" :id="`body-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasServicos">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-body`, 'section', `accordion-services-${codigo}5`), pesquisarServicoMenu()"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}5`">
              <i :id="`icon-services-${codigo}-body`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span>Body</span>
            </button>
            <div @click="openModalAddParametros('Body', codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <AtributesTabs :listaDadosAtributosHierarquia="listaDadosServicoAtributosHierarquia"
          @onAction="onActionInComponent" :entrada="String('B')" :ordem="String('5')" :menu="menu"
          :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)" />
      </div>
    </div>

    <!-- Atributos Saida -->
    <div v-if="saida === true" :id="`saida-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasServicos">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-saida`, 'section', `accordion-services-${codigo}6`), pesquisarServicoMenu()"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}6`">
              <i :id="`icon-services-${codigo}-saida`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span>Saida</span>
            </button>
            <div @click="openModalAddParametros('Saida', codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <AtributesTabs :listaDadosAtributosHierarquia="listaDadosServicoAtributosHierarquia"
          @onAction="onActionInComponent" :entrada="String('S')" :ordem="String('6')" :menu="menu"
          :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)" />
      </div>
    </div>

    <!-- Atributos Alerta -->
    <div v-if="alerta === true" :id="`alerta-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasServicos">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-alerta`, 'section', `accordion-services-${codigo}7`), pesquisarServicoMenu()"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}7`">
              <i :id="`icon-services-${codigo}-alerta`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span>Alerta</span>
            </button>
            <div @click="openModalAddParametros('Alerta', codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <AtributesTabs :listaDadosAtributosHierarquia="listaDadosServicoAtributosHierarquia"
          @onAction="onActionInComponent" :entrada="String('A')" :ordem="String('7')" :menu="menu"
          :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)" />
      </div>
    </div>

    <!-- Atributos Erro -->
    <div v-if="erro === true" :id="`erro-${parseInt(codigo.match(/\d+/)[0])}`" model="selectedListasServicos">
      <div class="card mb-4 mt-4">
        <div class="card-header" id="headingServices">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed services-collapsed"
              @click="alterarIcone(`icon-services-${codigo}-erro`, 'section', `accordion-services-${codigo}8`), pesquisarServicoMenu()"
              data-toggle="collapse" aria-expanded="false" :data-target="`#accordion-services-${codigo}8`">
              <i :id="`icon-services-${codigo}-erro`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span>Erro</span>
            </button>
            <div @click="openModalAddParametros('Erro', codigo, -1)" class="icon-content">
              <i style="font-size: 13px !important;float:right" class="fa-solid fa-add plus-icon"></i>
            </div>
          </h5>
        </div>

        <AtributesTabs :listaDadosAtributosHierarquia="listaDadosServicoAtributosHierarquia"
          @onAction="onActionInComponent" :entrada="String('W')" :ordem="String('8')" :menu="menu"
          :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)" />
      </div>
    </div>

    <!-- O Modal Adicionar Parametros -->
    <div v-if="showModalAddParametros" class="modal modal-add-parametros fade" id="myModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Adicionar Parâmetros</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Campo and Tipo row -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="objetoId" class="green-label">Campo:</label>
                  <select class="form-select select-modal modal-input" id="objetoId" :disabled="this.bloqueioCampo">
                    <option value="Selecione">Selecione</option>
                    <option value="Entrada">Entrada</option>
                    <option value="Header">Header</option>
                    <option value="Get">Get</option>
                    <option value="Form">Form</option>
                    <option value="Saida">Saída</option>
                    <option value="Alerta">Alerta</option>
                    <option value="Erro">Erro</option>
                    <option value="Body">Body</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="tipoAutenticacaoSelectAdicionar" class="green-label">Tipo:</label>
                  <select class="form-select select-modal modal-input"
                    @change="validarTipo('tipoAutenticacaoSelectAdicionar')" id="tipoAutenticacaoSelectAdicionar">
                    <option value="Selecione">Selecione</option>
                    <option value="O">Objeto</option>
                    <option value="C">Campo</option>
                    <option value="A">Autenticação</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Nome and Obrigatório row -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="nomeModalAdicionar" class="green-label">Nome:</label>
                  <input id="nomeModalAdicionar">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="formatoAdicionar" class="green-label">Formato:</label>
                  <select class="form-select select-modal modal-input" id="formatoAdicionar"
                    :disabled="this.bloqueioFormato">
                    <option value="Selecione" selected>Selecione</option>
                    <option value="A">Alfanumérico</option>
                    <option value="N">Numérico</option>
                    <option value="V">Valor</option>
                    <option value="O">Objeto - Container/classe</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Formato and Lista row -->
            <div class="row">

              <div class="col-md-6">
                <div class="form-outline">
                  <label for="obrigatorioId" class="green-label">Obrigatório:</label>
                  <select class="form-select select-modal modal-input" id="obrigatorioId">
                    <option value="">Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
                
              </div>
              

              <div class="col-md-6">
                <div class="form-outline">
                  <label for="listaId" class="green-label">Lista:</label>
                  <select class="form-select select-modal modal-input" id="listaId">
                    <option value="">Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="mt-1 col-12">
              <!-- Nav Tabs com MDB Modal -->
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link active" id="descricao-tab-adicionar" data-mdb-toggle="tab"
                    href="#descricaoAdicionar" role="tab" aria-controls="descricaoAdicionar"
                    aria-selected="true">Descrição</a>
                </li>
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link" id="dominio-tab-adicionar" data-mdb-toggle="tab" href="#dominioAdicionar"
                    role="tab" aria-controls="dominioAdicionar" aria-selected="false">Domínio</a>
                </li>
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link" id="observacao-tab-adicionar" data-mdb-toggle="tab" href="#observacaoAdicionar"
                    role="tab" aria-controls="observacaoAdicionar" aria-selected="false">Observação</a>
                </li>
              </ul>

              <!-- Tab content -->
              <div class="tab-content mt-5 mb-5" id="myTabContent">
                <!-- Aba Descrição (aberta por padrão) -->
                <div class="tab-pane fade show active" id="descricaoAdicionar" role="tabpanel"
                  aria-labelledby="descricao-tab-adicionar">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="descricaoModalAdicionar" class="green-label">Descrição:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal"
                        id="descricaoModalAdicionar"></textarea>
                    </div>
                  </div>
                </div>
                <!-- Aba Domínio -->
                <div class="tab-pane fade" id="dominioAdicionar" role="tabpanel"
                  aria-labelledby="dominio-tab-adicionar">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="dominioId" class="green-label">Domínio:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal"
                        id="dominioModalAdicionar"></textarea>
                    </div>
                  </div>
                </div>
                <!-- Aba Observação -->
                <div class="tab-pane fade" id="observacaoAdicionar" role="tabpanel"
                  aria-labelledby="observacao-tab-adicionar">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="observacaoId" class="green-label">Observação:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal"
                        id="observacaoModalAdicionar"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Footer buttons -->
          <div class="mt-5" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary"
                  style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1"></div>
              <div class="col-3">
                <button @click="salvarNovoParametro()" type="button" id="gestao-carteira"
                  style="width: 205% !important; color:white !important;" class="footer-button btn btn-primary active"
                  data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- O Modal Adicionar Segmentação -->
    <div v-if="showModalAddSegmentacao" class="modal modal-add-segmentacao fade" id="myModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" style="height: 600px;">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Adicionar Segmentação</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <!-- Nome and Obrigatório row -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="nomeModalAdicionar" class="green-label">Nome:</label>
                  <input id="nomeModalAdicionar">
                </div>
              </div>
              <div class="tab-content mt-5 mb-5" id="myTabContent">

                <div class="col-md-12">
                  <div class="form-outline">
                    <label for="observacaoId" class="green-label">Exemplo Rest/XML:</label>
                    <textarea rows="11" class="text-area-modal modal-input textarea-modal"
                      id="exemploRestXml"></textarea>
                  </div>
                </div>
              </div>

            </div>

            <div class="mt-1 col-12">
              <!-- Tab content -->
              <div class="tab-content mt-5 mb-5" id="myTabContent">


              </div>
            </div>

          </div>

          <!-- Footer buttons -->
          <div class="mt-5" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary"
                  style="width: 105% !important;" data-mdb-ripple-init>VOLTAR</button>
              </div>
              <div class="col-1"></div>
              <div class="col-3">
                <button @click="salvarNovaSegmentacao()" type="button" id="salvar-segmentacao"
                  style="width: 205% !important; color:white !important;" class="footer-button btn btn-primary active"
                  data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader'
import $ from 'jquery'; // Importando jQuery
import 'mdb-ui-kit'; // Importando o JavaScript do MDB
import * as ajaxUtils from '@/utils/ajax';
import AtributesTabs from './AtributeTabs.vue';
import * as validadorUtils from '@/utils/validador';
import SegmentacoesTabs from './SegmentacoesTabs.vue';


export default {
  name: "SectionTabs",
  data() {
    return {
      clone: false,
      showModal: false,
      showModalAddParametros: false,
      showModalAddSegmentacao: false,
      showModalEditParametros: false,
      bloqueioFormato: false,
      bloqueioCampo: false,
      selectedListasServicos: "",
      selectedListasSegmentacoes: "",
      selectedListasServicosCampo: "",
      selectedListasServicosAtributos: "",
      requestType: "",
      listaDadosServicos: [],
      listaDadosServicoCampos: [],
      listaDadosServicoAtributos: [],
      listaDadosServicoAtributosHierarquia: [],
      atualDataEditParametros: [],
      atributo: {
        tipo: "",
        nome: "",
        obrigatorio: "",
        formato: "",
        lista: "",
        descricao: "",
        observacao: "",
        idServicoApi: "",
        indexPai: "",
        disabledTipo: false,
      },
      servicoApi: {
        menu: "",
        introducao: "",
        url: "",
        metodo: "",
        requestType: "",
        idCatalogoApi: "",
        codigoMenuPai: ""
      },
      codigoMenuPai: "",
      tempTipo: "",
      tempNome: "",
      tempDescricao: "",
      tempDominio: "",
      tempObservacao: "",
      fluxoTela: [],
    };
  },
  props: {
    titulo: {
      type: String,
      required: false
    },
    descricao: {
      type: String,
      required: false
    },
    codigo: {
      type: String,
      required: true
    },
    codigoMenu: {
      type: String,
      required: false
    },
    subMenu: {
      type: Boolean,
      required: false
    },
    tipo: {
      type: String,
      required: false
    },
    menu: {
      type: String,
      required: false
    },
    header: {
      type: Boolean,
      required: false
    },
    get: {
      type: Boolean,
      required: false
    },
    entrada: {
      type: Boolean,
      required: false
    },
    form: {
      type: Boolean,
      required: false
    },
    body: {
      type: Boolean,
      required: false
    },
    saida: {
      type: Boolean,
      required: false
    },
    alerta: {
      type: Boolean,
      required: false
    },
    erro: {
      type: Boolean,
      required: false
    },
    section: { type: String, required: false, default: '' },
    atributos: { type: Array, required: false, default: () => [] },

    segmentacao: {
      type: Boolean,
      required: false
    },
  },
  components: {
    AtributesTabs,
    SegmentacoesTabs
  },
  methods: {
    async onActionInComponent(atributos) {
      // this.$emit('onActionAtribute', String(this.fluxoTela.sectionAcessado), atributos);
      this.$emit('onActionAtribute', String(this.fluxoTela.sectionIdAcessado), atributos);
    },
    async toggleCollapse(event) {
      // Fecha todos os collapses
      const allCollapses = document.querySelectorAll('.collapse');
      allCollapses.forEach(function (collapse) {
        if (collapse !== document.querySelector(event.target.getAttribute('data-target'))) {
          $(collapse).collapse('hide');
        }
      });

      // Abre o collapse clicado
      const targetCollapse = document.querySelector(event.target.getAttribute('data-target'));
      $(targetCollapse).collapse('toggle');
    },
    async mudarEstadoInput(event) {
      // Quando o valor do input mudar, marca a flag como true
      if (event.target.value !== this.valorAnterior) {
        this.mudou = true;
      }
    },
    async mudarTipo(status, metodo) {
      const formato = metodo === 1 ? 'formatoAdicionar' : 'formato';

      if (status) {
        this.bloqueioFormato = true;

        setTimeout(function () {
          $(`#${formato}`).val('O');
        }, 40);
      }
      else {
        this.bloqueioFormato = false;

        if (metodo === 1) {
          setTimeout(function () {
            $(`#${formato}`).val('Selecione');
          }, 40);
        }
      }
    },
    // habilita/desabilita campos e mostra/esconde o botão Salvar do modal de Segmentação
    setSegmentacaoModalMode(mode, seg = null) {
      const isView = mode === 'view';

      // preencher/limpar
      $('#nomeModalAdicionar').val(seg ? seg.nome || '' : '');
      $('#exemploRestXml').val(seg ? seg.exemploRestXml || '' : '');

      // bloquear/desbloquear
      $('#nomeModalAdicionar').prop('disabled', isView);
      $('#exemploRestXml').prop('disabled', isView);

      $('#salvar-segmentacao').toggle(!isView);
    },

    async abrirModalViewSegmentacao({ index, seg }) {
      this.showModalAddSegmentacao = true;

      setTimeout(async () => {
        const modalElement = document.querySelector('.modal-add-segmentacao');
        const modalInstance = await new mdb.Modal(modalElement);
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());

        this.setSegmentacaoModalMode('view', seg);

        await modalInstance.show();
      }, 100);
    },
    async validarTipo(selectName) {
      const tipo = $(`#${selectName}`).val();

      const metodo = selectName.includes("Adicionar") ? 1 : 0;

      tipo === 'O' ? this.mudarTipo(true, metodo) : this.mudarTipo(false, metodo);
    },
    async mudarRequestType() {
      const tipoRequest = $('#requestType').val();
      const idServicoApi = $('#idServicoApi').val();
      const introducao = $('#introducao').val();
      const metodo = $('#metodo').val();
      const url = $('#url').val();

      let tipoRequestFormatado = tipoRequest.slice(0, 1).toUpperCase();

      if (tipoRequest === "PUT") tipoRequestFormatado = "T";

      const bodyData = {
        "introducao": String(introducao),
        "idServicoApi": String(idServicoApi),
        "url": String(url),
        "metodo": String(metodo),
        "requestType": String(tipoRequestFormatado)
      };

      let jsonRequest;

      jsonRequest = JSON.stringify(bodyData);

      await ajaxUtils.postOK(
        '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/salvar-dados-prinicipais-servico',
        jsonRequest,
        '',
        ''
      );
    },
    async salvarPosFoco(event) {
      const tipoRequest = $('#requestType').val();
      const idServicoApi = $('#idServicoApi').val();
      const introducao = $('#introducao').val();
      const metodo = $('#metodo').val();
      const url = $('#url').val();

      const codigoXmlFimOut = $('#codigoXmlFimOut').val();
      const codigoXmlInicioOut = $('#codigoXmlInicioOut').val();
      const codigoXmlFim = $('#codigoXmlFim').val();
      const codigoXmlInicio = $('#codigoXmlInicio').val();

      let tipoRequestFormatado = tipoRequest.slice(0, 1).toUpperCase();

      if (tipoRequest === "PUT") tipoRequestFormatado = "T";

      const bodyData = {
        "codigoXmlFimOut": String(codigoXmlFimOut),
        "codigoXmlInicioOut": String(codigoXmlInicioOut),
        "codigoXmlFim": String(codigoXmlFim),
        "codigoXmlInicio": String(codigoXmlInicio),
        "introducao": String(introducao),
        "idServicoApi": String(idServicoApi),
        "url": String(url),
        "metodo": String(metodo),
        "requestType": String(tipoRequestFormatado)
      };

      let jsonRequest;

      jsonRequest = JSON.stringify(bodyData);

      if (this.mudou) {
        await ajaxUtils.postOK(
          '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/salvar-dados-prinicipais-servico',
          jsonRequest,
          '',
          ''
        );

        this.mudou = false; // Resetando a flag
      }
    },
    async salvarNovoParametro() {
      // ID do serviço e índice do pai


      const idServicoApi = this.atributo.idServicoApi;
      const indexPai = this.atributo.indexPai ? this.atributo.indexPai : -1;
      const nome = $('#nomeModalAdicionar').val();
      const descricao = $('#descricaoModalAdicionar').val();
      const dominio = $('#dominioModalAdicionar').val();
      const observacao = $('#observacaoModalAdicionar').val();
      const tipo = $('#tipoAutenticacaoSelectAdicionar').val();
      const lista = $('#listaId').val();
      const obrigatorio = $('#obrigatorioId').val();
      const formato = $('#formatoAdicionar').val();


      let entrada = $('#objetoId').val();

      switch (entrada) {
        case "Header":
          entrada = "H"
          break;
        case "Entrada":
          entrada = "E"
          break;
        case "Get":
          entrada = "G"
          break;
        case "Form":
          entrada = "F"
          break;
        case "Saida":
          entrada = "S"
          break;
        case "Alerta":
          entrada = "A"
          break;
        case "Erro":
          entrada = "W"
          break;
        case "Body":
          entrada = "B"
          break;
      }

      const payload = {
        entrada: entrada,
        tipo: tipo === 'Selecione' ? '' : tipo,
        nome: nome,
        obrigatorio: obrigatorio,
        formato: formato === 'Selecione' ? '' : formato,
        lista: lista,
        descricao: descricao,
        dominio: dominio,
        observacao: observacao,
      };

      const camposObrigatorios = validadorUtils.obterCamposObrigatoriosPadraoParametro();

      const erro = validadorUtils.validarCamposObrigatorios(payload, camposObrigatorios);

      if (erro) {
        return;
      }


      const requestAjax = await ajaxUtils.postOK(
        `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-atributo/${idServicoApi}/${indexPai}`,
        JSON.stringify(payload),
        '',
        ''
      );

      let sections = '';

      if (requestAjax) {
        this.closeModal();

        alertUtils.alertSuccess("Parâmetro salvo com sucesso!");

        if (this.bloqueioCampo === true) sections = this.fluxoTela.sectionIdAcessado;

        this.$emit('onActionAtribute', String(sections));

        this.$emit('onNewSection', String(entrada));
      } else {
        alertUtils.alertError("Erro ao salvar Parâmetro!");
      }

      return requestAjax;
    },
    async openModalAddParametros(tipo, idServicoApi, indexPai) {

      this.requestType = tipo ? tipo : "";

      tipo ? this.bloqueioCampo = true : this.bloqueioCampo = false;

      this.atributo.idServicoApi = idServicoApi || "";
      this.atributo.indexPai = indexPai !== null ? indexPai : "";
      this.atributo.disabledTipo = tipo !== "";
      this.showModalAddParametros = true;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-add-parametros');
          const modalInstance = await new mdb.Modal(modalElement);

          // Antes de abrir o modal
          document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());

          await modalInstance.show();

          this.resetForm();

          $("#objetoId").val(String(tipo));
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },

    async openModalAddSegmentacao(idServicoApi, indexPai) {

      this.showModalAddSegmentacao = true;
      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-add-segmentacao');
          const modalInstance = await new mdb.Modal(modalElement);

          document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());

          this.setSegmentacaoModalMode('add');

          await modalInstance.show();

          this.resetForm();

          $("#objetoId").val(String(tipo));
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async openModalEditarParametros(tipo, idServicoApi, modalData) {
      switch (tipo) {
        case 'Entrada':
          tipo = 'E';
          break;
        case 'Header':
          tipo = 'H';
          break;
        case 'Get':
          tipo = 'G';
          break;
        case 'Saida':
          tipo = 'S';
          break;
        case 'Alerta':
          tipo = 'W';
          break;
        case 'Erro':
          tipo = 'U';
          break;
        case 'Body':
          tipo = 'B';
          break;
        default:
          break;
      }

      this.requestType = tipo ? tipo : "";

      this.showModalEditParametros = true;
      this.atributo = modalData;
      this.atributo.idServicoApi = idServicoApi;
      this.atualDataEditParametros = modalData;

      this.tempTipo = this.atributo.tipo;
      this.tempNome = this.atributo.nome;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-edit-parametros');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();

          $("#formato").val(this.atributo.formato);

          this.validarTipo('tipoAutenticacaoSelect');
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error);
      }
    },
    async closeModal() {
      this.showModal = false;

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem

      this.$emit('onActionUpdate', "");
    },
    async resetForm() {
      // Resetando os campos <select>
      $('#tipoAutenticacao').val('Selecione');
      // Resetando os campos <select>
      $('#tipoAutenticacaoSelect').val('Selecione');
      $('#tipoAutenticacaoSelectAdicionar').val('Selecione');
      // Resetando os campos <select>
      $('#formato').val('Selecione');
      $('#formatoAdicionar').val('Selecione');

      // Resetando os campos de <input> e <textarea>
      $('#descricaoModalAdicionar').val('');
      $('#dominioModalAdicionar').val('');
      $('#observacaoModalAdicionar').val('');

      $('#nomeModalAdicionar').val('');

      $('#obrigatorioId').val('');

      $('#formato').val('');

      $('#listaId').val('');

      $('#tipoAutenticacaoSelect').val('');
    },
    async salvarFluxo(codigo, tipoFluxo, iconId) {
      if (!this.fluxoTela) {
        this.fluxoTela = {};
      }

      if (tipoFluxo === 'section') {
        this.fluxoTela.sectionAcessado = codigo;
        this.fluxoTela.sectionIdAcessado = iconId;
      }

      if (tipoFluxo === 'service') {
        this.fluxoTela.serviceAcessado = codigo;
      }

      if (tipoFluxo != 'service' && tipoFluxo != 'section') {
        this.fluxoTela.menuAcessado = codigo;
      }
    },
    async alterarIcone(iconId, tipoFluxo, codigo) {
      this.salvarFluxo(codigo, tipoFluxo, iconId);

      const iconeSetadoDown = $('#' + iconId).hasClass('fa-angle-down');
      const iconeSetadoRight = $('#' + iconId).hasClass('fa-angle-right');

      if (iconeSetadoRight === true) {
        $('#' + iconId).removeClass('fa-angle-right');

        $('#' + iconId).addClass('fa-angle-down');
      } else if (iconeSetadoDown === true) {
        $('#' + iconId).removeClass('fa-angle-down');

        $('#' + iconId).addClass('fa-angle-right');
      }
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async buscarServico(idServico) {
      loaderUtils.addLoarder();

      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

      let urlApi = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consultar-servico/${idServico}`;
      let method = 'GET';
      let requestOptions = { method };


      try {
        const response = await fetch(urlApi, requestOptions);
        if (!response.ok) throw new Error('Fechar');

        const data = await response.json();

        const mostrarElementos = async (codigo) => {
          await delay(100);

          const seções = ['header', 'get', 'entrada', 'form', 'body', 'saida', 'alerta', 'erro'];

          seções.forEach(seção => {
            const elemento = $(`#${seção}-${codigo}`);
            if (elemento.find('div').length > 7) {
              elemento.css('display', 'unset');
            }
          });
        };

        const itemExiste = Array.isArray(this.listaDadosServicoCampos) && this.listaDadosServicoCampos.some(item => item.idServicoApi === data.idServicoApi);

        if (Array.isArray(this.listaDadosServicoCampos) && this.listaDadosServicoCampos.length >= 1) {
          if (!itemExiste) {
            this.listaDadosServicoCampos.push(data);

            for (const dadoServico of this.listaDadosServicos) {
              const codigo = (dadoServico.codigo.match(/\d+/) || [])[0];
              if (codigo) await mostrarElementos(codigo);
            }

            const novoItem = {
              id: idServico,
              atributos: data.atributos
            };

            this.listaDadosServicoAtributos.push(data.atributos);
            this.listaDadosServicoAtributosHierarquia.push(novoItem);

          }

          for (const dadoServico of this.listaDadosServicos) {
            const codigo = (dadoServico.codigo.match(/\d+/) || [])[0];
            if (codigo) await mostrarElementos(codigo);
          }

        } else {
          this.listaDadosServicoCampos.push(data);

          for (const dadoServico of this.listaDadosServicos) {
            const codigo = (dadoServico.codigo.match(/\d+/) || [])[0];
            if (codigo) await mostrarElementos(codigo);
          }

          const novoItem = {
            id: idServico,
            atributos: data.atributos
          };

          this.listaDadosServicoAtributos.push(data.atributos);
          this.listaDadosServicoAtributosHierarquia.push(novoItem);
          // alert(98);
        }


        return data;

      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
      } finally {
        // alert("finalizado!");
        loaderUtils.removeLoader();
      }
    },
    async pesquisarServicoMenu() {
      loaderUtils.addLoarder();

      const codigoMenu = this.codigoMenu;

      // Acesse o hash da URL
      const hash = window.location.hash;

      // Remova a primeira barra ("/") e separe a string com base nas barras
      const idCatalogo = hash.split('/').pop();

      if (idCatalogo != undefined) {
        let urlApi;
        let method;
        let requestOptions;

        urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/servicos/' + idCatalogo + '/' + codigoMenu;
        method = 'GET';

        requestOptions = {
          method: method
        };

        try {
          fetch(urlApi, requestOptions)
            .then(async (response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error('Fechar');
              }
            })
            .then(async (data) => {
              this.listaDadosServicos = data;

              this.buscarServico(this.codigo);

              loaderUtils.removeLoader();

              return data;
            })
            .catch((error) => {
              console.log(error);
            }).finally(() => 'loaderUtils.removeLoader()');

        } catch (error) {
          console.error('Erro ao realizar busca:', error);
          alertUtils.alertError('Erro ao realizar busca:' + error);
        }
      }
    },

    getServicoAtual(codigo) {
      const servico = this.listaDadosServicoAtributosHierarquia.find(item => item.id === codigo);
      if (servico) {
        return servico;
      } else {
        return { atributos: [] }; // Retorna um objeto vazio com a propriedade atributos
      }
    },
    async fluxoTelaAtributos() {
      if (typeof this.section === 'string' && this.section) {
        await $(`#${this.section}`).click();
      }

      if (Array.isArray(this.atributos) && this.atributos.length > 0) {
        for (const atributo of this.atributos) {
          setTimeout(() => {
            $('#' + atributo).click();
          }, 2000);
        }
      }
    },
    async salvarNovaSegmentacao() {
      // Recupera o id do serviço e os campos do modal
      const idServicoApi = this.codigo;
      const nome = ($('#nomeModalAdicionar').val() || '').trim();
      const exemploRestXml = ($('#exemploRestXml').val() || '').trim();


      if (!idServicoApi) {
        alertUtils.alertError('Serviço inválido. Tente abrir o modal novamente.');
        return;
      }
      if (!nome) {
        alertUtils.alertError('Informe o Nome da segmentação.');
        return;
      }
      if (!exemploRestXml) {
        alertUtils.alertError('Informe o Exemplo Rest/XML.');
        return;
      }

      const payload = {
        nome,
        exemploRestXml
      };

      try {
        const requestAjax = await ajaxUtils.postOK(
          `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-segmentacao/${idServicoApi}`,
          JSON.stringify(payload),
          '',
          ''
        );

        if (requestAjax) {
          this.closeModal();
          alertUtils.alertSuccess('Segmentação salva com sucesso!');

          await this.buscarServico(this.codigo);

          if (this.$refs.segTabs && this.$refs.segTabs.carregar) {
            await this.$refs.segTabs.carregar();
          }

          this.$emit('onNewSegmentacao', payload);
        } else {
          alertUtils.alertError('Erro ao salvar Segmentação!');
        }

        return requestAjax;
      } catch (error) {
        console.error('Erro ao salvar Segmentação:', error);
        alertUtils.alertError('Erro ao salvar Segmentação: ' + error);
      }
    }

  },
  async mounted() {
    const temSection = typeof this.section === 'string' && this.section.length > 0;
    const temAtributos = Array.isArray(this.atributos) && this.atributos.length > 0;

    if (temSection || temAtributos) await this.fluxoTelaAtributos();

    this.pesquisarServicoMenu();

    document.body.addEventListener('click', this.setandoVisibilidade);

    this.idCatalogo = this.$route.params.idCatalogo;

    if (this.idCatalogo && this.idCatalogo.indexOf("-clone") !== -1) {
      this.clone = true;
    }
  }

}
</script>

<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/style.css';
</style>
